// Angular
import { Component, OnInit, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
// Layout
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { AppState } from '../../../../core/reducers';
import { currentUser, User, AuthService } from '../../../../core/auth';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TwixorService } from '../../../../core/services/twixor.service';
import { ManageNotificationSoundComponent } from '../manage-notification-sound/manage-notification-sound.component';
import { NotificationService } from '../../../../core/lists';
import { LevelType } from 'src/app/notification/enums/level-type.enum';
import { ImpersonateTeamUserComponent } from '../impersonate-team-user/impersonate-team-user.component';

@Component({
  selector: 'kt-quick-user-panel',
  templateUrl: './quick-user-panel.component.html',
  styleUrls: ['./quick-user-panel.component.scss'],
})
export class QuickUserPanelComponent implements OnInit {
  user$: Observable<User>;
  @ViewChild('offCanvas') offCanvas;
  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'offcanvas',
    placement: 'right',
    closeBy: 'kt_quick_user_close',
    toggleBy: 'kt_quick_user_toggle',
  };
  constructor(
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private twixorService: TwixorService,
    private auth: AuthService,
    private router: Router,
    public dialog: MatDialog,
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.user$ = this.store.pipe(select(currentUser));
  }

  /**
   * Log out
   */
  logout() {
    // this.store.dispatch(new Logout());
    this.auth.logout(false, true);
  }

  closeOffCanvas() {
    const element = $('#kt_quick_user_close')[0] as HTMLElement;
    if (element) element.click();
  }

  redirectToUserDetails(userId) {
    this.closeOffCanvas();
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigate(['/user-management/users/edit/' + userId]);
  }
  openNotification() {
    this.closeOffCanvas();
    this.router.navigate(['/']).then(() => {
      this.router.navigate(['notifications'], { queryParams: { level: LevelType.USER } });
    });
  }
  openMangeNotificationDialog() {
    this.notificationService.getNotificationSettings().subscribe((result) => {
      this.dialog.open(ManageNotificationSoundComponent, { data: { notification: result } });
    });
  }
  openImpersonationDialog() {
    this.dialog.open(ImpersonateTeamUserComponent, {
      width: '450px',
      height: '300px',
    });
  }
}
